import React, { useEffect, useRef } from "react";

const TrialStart = ({ onGoogle, onEmail }) => {
  const googleButtonRef = useRef(null);

   useEffect(() => {

    const renderGoogleButton = () => {

      if (!window.google || !googleButtonRef.current) {
        return;
      }

      // Prevent duplicate button rendering
      googleButtonRef.current.innerHTML = "";

      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,

        callback: onGoogle,
      });

      window.google.accounts.id.renderButton(
        googleButtonRef.current,
        {
          theme: "outline",
          size: "large",
          text: "continue_with",
          shape: "rectangular",
          width: 300,
          logo_alignment: "left",
        }
      );
    };


    if (window.google) {
      renderGoogleButton();
    } else {

      // Google script may still be loading
      const interval = setInterval(() => {

        if (window.google) {
          clearInterval(interval);
          renderGoogleButton();
        }

      }, 100);

      return () => clearInterval(interval);
    }

  }, [onGoogle]);


  return (
    <div className="trial-card">

      <img
        src="/wordmarklogo.png"
        alt="Aamantran"
        className="trial-logo"
      />

      <h2 className="trial-card-heading">
        Start Your Free Trial
      </h2>

      <p className="trial-helper-text">
        (3-day free trial to explore the invite,
        <br />
        Upgrade anytime to keep it active)
      </p>

      <div className="trial-points">

        <span>
          <span className="trial-check">✓</span>
          No card required
        </span>

        <span>
          <span className="trial-check">✓</span>
          Ready in 5 minutes
        </span>

      </div>

      <div
        ref={googleButtonRef}
        className="google-button-container"
      />


      <div className="trial-divider">
        <span>or</span>
      </div>


      <button
        className="email-button"
        onClick={onEmail}
      >
        Continue with email
      </button>

    </div>
  );
};

export default TrialStart;